import React from 'react'
import Layout from '../components/layout'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import TaskCalculator from '../components/TaskCalculator'

const TaskCalc = () => {
    return (
        <Layout>
            <Container>
                <Row>
                    <Col md={12}>
                        <TaskCalculator />
                    </Col>
                </Row>
            </Container>

        </Layout>
    )
}

export default TaskCalc